import { Component, OnInit } from '@angular/core';
import { PageTitleService } from '../../core/page-title/page-title.service';
import { ChkService } from '../../service/chk.service';
declare var $ : any;

@Component({
  selector: 'app-nosotros',
  templateUrl: './nosotros.component.html',
  styleUrls: ['./nosotros.component.scss']
})
export class NosotrosComponent implements OnInit {

  /* Variables */
  services : any;
  about    : any;
  team     : any;
  contact  : any;

  constructor(private pageTitleService: PageTitleService, private service:ChkService) { 

    /* Page title */
			this.pageTitleService.setTitle(" ¿Qué es DYTRON? ");

			/* Page subTitle */
			this.pageTitleService.setSubTitle(" Dytron es una empresa dedicada a dar soluciones de domótica, automatización de hogares dando un confort requerido por los clientes. Combinamos una serie de marcas de alta calidad y renombre a nivel mundial para realizar una integración única y simple cumpliendo con los más altos estándares de calidad y con las exigencias mas grandes y locas de los clientes dando lugar a la creación de ambientes de alto confort y con la mas alta tecnología. ");

			this.service.getServicesUs().
				 subscribe(response => {this.services = response},
									err       => console.log(err),
									()        =>this.services
							 );
			//sERVICIO QUE DA MISION Y VISION
			this.service.getAbout().
				 subscribe(response => {this.about = response},
									 err      => console.log(err),
									 ()       => this.about
							 );

			this.service.getTeam().
				 subscribe(response => {this.team = response},
									 err      => console.log(err),
									 ()       => this.team
							 );

			this.service.getContactContent().
				 subscribe(response => {this.contact = response},
									 err      => console.log(err),
									 ()       => this.contact
							 );

  }

  ngOnInit(){
  }

  /*
	 * Social links
	 */
	socialDetails : any = [
		{ url: 'https://www.facebook.com/', icon : 'fa-facebook'},
		{ url: '', icon : 'fa-twitter text-info'},
		{ url: '', icon : 'fa-pinterest text-danger'},
	]

	/*
	 * Classes of social ul, li
	 */
	socialsClasses : any = {ulClass:"", liClass:"", linkClass:""}

}
